import React from 'react';
import BuilderNumericalMenu from '../../../../../components/Builder/BuilderFields/BuilderNumericalMenu';
import { significanceConfidenceLevelSelector } from '../../../../../redux/selectors/builder';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { setSignificanceConfidenceLevel } from '../../../../../redux/slices/oldBuilder';

const values = [90, 95, 99];

const SignificanceLevel = () => {
  const dispatch = useAppDispatch();
  const significanceConfidenceLevel = useAppSelector(
    significanceConfidenceLevelSelector,
  );

  const handleChange = (newValue: number) => {
    dispatch(setSignificanceConfidenceLevel({ newValue }));
  };

  return (
    <div>
      <BuilderNumericalMenu
        label="while maintaining a"
        value={significanceConfidenceLevel}
        options={values.map((value) => ({
          text: `${value}%`,
          value,
        }))}
        placeholder="Enter a value"
        suffix="%"
        onChange={handleChange}
        min={values[0]}
        max={values[values.length - 1]}
      />
    </div>
  );
};

export default SignificanceLevel;
